import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TiTick } from "react-icons/ti";
import { Link } from "react-router-dom";
import axios from "axios";
import "@emran-alhaddad/saudi-riyal-font/index.css";

const HomeSection1Cards = () => {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language; // 'en' or 'ar'
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(
          "https://demo-two.keytime.sa/api/services",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const sortedServices = response.data.sort((a, b) => b.id - a.id); // Sorting services
        const latestThreeServices = sortedServices.slice(0, 3); // Taking the latest 3
        setServices(latestThreeServices);
      } catch (error) {
        setError("Failed to fetch services.");
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  return (
    <div className="flex lg:flex-row flex-col gap-3 justify-center items-center lg:h-[400px]">
      {loading && <p>Loading...</p>}
      {error && <p>{error}</p>}
      {!loading &&
        !error &&
        services.map((service) => (
          <Link
            key={service.service_id}
            to={`/services/${service.service_id}`} // Navigate to service details
            className="shadow-top-blue w-[370px] py-8 px-5 border rounded-lg gap-10 flex flex-col items-end"
          >
            <div
              className={`flex flex-col ${
                activeLanguage === "ar" ? "items-end" : ""
              } gap-5`}
            >
              <img src="/Images/lllll.png" className="w-10 h-10" alt="logo" />
              <div className="justify-end items-end flex flex-col gap-3 w-full">
                <h1
                  className={`text-[20px] font-black ${
                    activeLanguage === "ar" ? "text-end" : ""
                  } text-[#003E6F]`}
                >
                  {activeLanguage === "ar"
                    ? service.name
                    : activeLanguage === "en"
                    ? service.name_en
                    : activeLanguage === "ur"
                    ? service.name_ur
                    : null}
                </h1>
                <div
                  className={`subsection flex ${
                    activeLanguage === "ar" ? "flex-row" : "flex-row-reverse"
                  } gap-2`}
                >
                  <h3
                    className={`text-[18px] ${
                      activeLanguage === "ar" ? "text-end" : ""
                    } max-w-xs mx-auto break-words text-[#667085] font-medium`}
                  >
                    
                    {activeLanguage === "ar"
                    ? service.description
                    : activeLanguage === "en"
                    ? service.description_en
                    : activeLanguage === "ur"
                    ? service.description_ur
                    : null}
                  </h3>
                  <div className="w-12 h-5 flex items-center justify-center rounded-full bg-[#DAF4E8] mt-3">
                    <TiTick size={15} style={{ fill: "green" }} />
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                activeLanguage === "ar" ? "justify-end" : ""
              } items-center flex content-center w-full transition duration-[100ms] gap-1`}
            >
              <span className="text-[18px] text-[#081F2F] font-bold">
                {t("yearly")}
              </span>
              {/* <span className="text-[18px] text-[#667085] font-black">
                {service.currency}
              </span> */}
              <span className="text-[23px] text-[#081F2F] font-black icon-saudi_riyal">
                {service.price}
              </span>
            </div>
          </Link>
        ))}
    </div>
  );
};

export default HomeSection1Cards;
